import { render, staticRenderFns } from "./vue-zoomer.vue?vue&type=template&id=25328788&scoped=true&"
import script from "./vue-zoomer.vue?vue&type=script&lang=js&"
export * from "./vue-zoomer.vue?vue&type=script&lang=js&"
import style0 from "./vue-zoomer.vue?vue&type=style&index=0&id=25328788&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25328788",
  null
  
)

export default component.exports